import { Moon, Sun } from 'lucide-solid'
import { Show, createEffect, createSignal } from 'solid-js'
import { css } from 'styled-system/css'
import { IconButton } from './ui/icon-button'

const attachDarkModeToHtml = (darkmode: boolean) => {
	const html = document.querySelector('html')
	html?.classList.remove('dark', 'light')
	html?.classList.add(darkmode ? 'dark' : 'light')
}

const persistedDarkmode = JSON.parse(localStorage.getItem('darkmode') ?? 'false')
export const [darkmode, setDarkMode] = createSignal(persistedDarkmode)

export const DarkMode = () => {
	const toggleDarkMode = () => {
		localStorage.setItem('darkmode', String(!darkmode()))
		setDarkMode(!darkmode())
		attachDarkModeToHtml(darkmode())
	}

	createEffect(() => attachDarkModeToHtml(darkmode()))

	return (
		<div>
			<IconButton
				onClick={toggleDarkMode}
				variant="ghost"
			>
				<Show
					when={darkmode()}
					fallback={
						<Sun
							class={css({ color: 'orange' })}
							size={32}
						/>
					}
				>
					<Moon
						class={css({ color: 'plum' })}
						size={32}
					/>
				</Show>
			</IconButton>
		</div>
	)
}
